import Decimal from 'decimal.js';

import {
  DispositiveProvisionDispositionKind,
  DispositiveProvisionTransferTaxKind,
  TransferMethod,
} from '@/types/schema';

import {
  DispositiveProvisionsFormRecipient,
  RecipientKind,
} from '../DispositiveProvisionsForm.types';

export interface SelectedRecipient {
  id: string;
  displayName: string;
  kind: RecipientKind;
  transferTaxKind: DispositiveProvisionTransferTaxKind | '';
}

export type SplitDistributionKind =
  | 'percentage'
  | 'amount'
  | 'formula'
  | 'asset';

export interface SplitDispositionFormShape {
  distributionKind: SplitDistributionKind;
  distributionValue: Decimal | null;
  formulaKind: DispositiveProvisionDispositionKind | '';
  /** Max distribution amount for percentage distributions */
  maxDistributionAmount: Decimal | null;
  selectedRecipients: SelectedRecipient[];
  /** Asset-specific fields (used when distributionKind === 'asset') */
  assetGroupIds: string[];
  assetStaticIds: string[];
  insurancePolicyIds: string[];
  ownershipStakeIds: string[];
  dispositionAssetPercentage: Decimal | null;
  transferMethod: TransferMethod;
}

export interface SplitDispositionModalResult {
  recipients: DispositiveProvisionsFormRecipient[];
}

export const SPLIT_DISTRIBUTION_KIND_OPTIONS: {
  display: string;
  value: SplitDistributionKind;
}[] = [
  {
    display: '%',
    value: 'percentage',
  },
  {
    display: '$',
    value: 'amount',
  },
  {
    display: 'ƒ(x)',
    value: 'formula',
  },
  {
    display: 'Asset',
    value: 'asset',
  },
];
